import React from 'react';
import logo from '../../assets/soundive/soundive_yellow.png';

export default function Logo() {
  return (
    <div style={{ width: '200px', margin: '2vh auto' }}>
      <img alt="Soundive Agami" src={logo} width="100%" />
    </div>
  );
}
